export const SUPPORTED_COUNTRIES = ['fr', 'pt', 'nl', 'be', 'lu', 'de', 'ch', 'es', 'it', 'uk', 'com'] as const;
export type AppCountry = (typeof SUPPORTED_COUNTRIES)[number];

export const COUNTRY_DOMAIN_SUFFIXES: Record<AppCountry, string[]> = {
    fr: ['fr'],
    pt: ['pt'],
    nl: ['nl'],
    be: ['be'],
    lu: ['lu'],
    de: ['de'],
    ch: ['ch'],
    es: ['es'],
    it: ['it'],
    uk: ['co.uk'],
    com: ['com']
};
